export enum QuizToastActions {
  DELETE = 'delete',
  PURGE = 'purge',
  MERGE = 'merge',
  RENAME = 'rename',
  RESTORE = 'restore',
  CREATE_FOLDER = 'create-folder',
  CREATE_QUIZ = 'create-quiz',
  COPY = 'copy',
  IMPORT = 'import',
  ERROR = 'error',
}

export { apiToaster } from './apiToastActions';
